import _ from 'lodash'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime, isBlank } from 'common/usual'
import {
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  TextField,
} from '@material-ui/core'
import AddBtn from 'components/AddBtn'
import EditBtn from 'components/EditBtn'
import { experimentListPromise, PLATFORM_LABELS } from 'api/Experiment'
import { useLocation } from 'react-router-dom'

// The DB-driven A/B tables. RandomItems in enum_type.js is the deploy-gated alternative nobody
// should be adding to, which is why this page exists at all.
export default function ExperimentList (props) {
  const ref = useRef()
  const location = useLocation()
  const [data, setData] = useState({})
  const [params, setParams] = useState({})

  useEffect(() => {
    let cancelled = false
    const query = Object.fromEntries(new URLSearchParams(location.search).entries())

    setParams({ page: 1, ...query })
    experimentListPromise(query).then(resp => { if (!cancelled) setData(resp || {}) })

    return () => { cancelled = true }
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const query = Object.fromEntries(new URLSearchParams(location.search))
    const next = _.pickBy({ ...query, page: 1, ...payload }, _.identity)
    setParams(next)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(next)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  return (
    <div className={'root'}>
      <div className={'content'}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              variant='outlined'
              size='small'
              placeholder='Experiment name'
              value={params.keyword || ''}
              className='background-color'
              onChange={event => handleParamsChange({ keyword: event.target.value }, 500)}
            />
          </Grid>
          <Grid item xs={8} className='flex-right'>
            <AddBtn color='primary' variant='contained' onClick={() => props.history.push('/experiments/add')}>
              Add
            </AddBtn>
          </Grid>
        </Grid>

        <br />

        <Card>
          <CardHeader
            title='Experiments'
            subheader='Every new A/B test belongs here rather than in RandomItems, which needs a deploy to change a rate and keeps rate-0 entries live for already-assigned users.'
          />
          <CardContent className={'table-content'}>
            <PerfectScrollbar>
              <div className={'inner'}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Country</TableCell>
                      <TableCell>Platform</TableCell>
                      <TableCell>Start BMI</TableCell>
                      <TableCell>New User Only</TableCell>
                      <TableCell>Active</TableCell>
                      <TableCell>Updated At</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data.rows && data.rows.map(experiment => (
                      <TableRow key={experiment.id} hover>
                        <TableCell>{experiment.id}</TableCell>
                        <TableCell>{experiment.name}</TableCell>
                        <TableCell>{isBlank(experiment.countryId) ? '-' : experiment.countryId}</TableCell>
                        {/* no platform means every platform; a value the API added and this map has
                            not caught up with is shown raw rather than read as "every platform" */}
                        <TableCell>
                          { isBlank(experiment.platform)
                            ? 'every platform'
                            : (PLATFORM_LABELS[experiment.platform] || experiment.platform) }
                        </TableCell>
                        <TableCell>{isBlank(experiment.startBmi) ? '-' : experiment.startBmi}</TableCell>
                        <TableCell>{experiment.newUserOnly ? 'TRUE' : 'FALSE'}</TableCell>
                        <TableCell>{experiment.active ? 'TRUE' : 'FALSE'}</TableCell>
                        <TableCell>{formatDateTime(experiment.updatedAt)}</TableCell>
                        <TableCell>
                          <EditBtn history={props.history} path={`/experiments/edit/${experiment.id}`} />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </PerfectScrollbar>
          </CardContent>

          <CardActions className='flex-right'>
            <TablePagination
              component='div'
              rowsPerPage={10}
              page={(params.page || 1) - 1}
              count={data.count || 0}
              rowsPerPageOptions={[10]}
              onPageChange={handlePageChange}
            />
          </CardActions>
        </Card>
      </div>
    </div>
  )
}
